import {
  GetIntroducingBrokerMembersParams,
  IntroducingBrokerMember,
} from "@letsbit/malcolmlb";
import {
  SWRInfiniteResponseCustom,
  useAuthInfiniteSWR,
} from "hooks/utils/useAuthSWR";
import { ApiContext } from "providers/ApiProvider";
import { useContext } from "react";

export const GET_INTRODUCING_BROKER_MEMBERS_LIMIT = 100;
export const SWR_INTRODUCING_BROKER_MEMBERS_KEY =
  "get-introducing-broker-members";

export const useGetMembers = (
  params?: GetIntroducingBrokerMembersParams,
): SWRInfiniteResponseCustom<IntroducingBrokerMember[]> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthInfiniteSWR(
    [SWR_INTRODUCING_BROKER_MEMBERS_KEY],
    async (withPage): Promise<IntroducingBrokerMember[]> => {
      const { data } = await memberInstance.partner.getMembers(withPage[0][1]);
      return data.members;
    },
  );
  const { data, ...rest } = swr;

  return {
    ...rest,
    data: data?.map((item) =>
      item.filter(
        (member) =>
          member.email.includes(params?.email || "") ||
          `${member.natural_person_data?.first_name || ""} ${member.natural_person_data?.last_name || ""}`
            .toLocaleLowerCase()
            .includes(params?.email || ""),
      ),
    ),
  };
};
